import * as React from "react";

interface StickyHeaderContextValue {
  hasStickyHeader: boolean;
  setHasStickyHeader: (v: boolean) => void;
  toggleSidebar: boolean;
  /**
   * Single-entry "contextual return banner" slot (see
   * docs/proposals/workflow-return-navigation.md, PR #524). MainLayout renders
   * whatever is set here between the app breadcrumb and the routed page's own
   * header — NOT a stack, exactly one entry at a time. A page registers its
   * banner via the `useReturnBanner` hook rather than calling `setReturnBanner`
   * directly, so it's always cleared automatically on unmount / when its
   * `returnTo` goes away.
   */
  returnBanner: React.ReactNode | null;
  setReturnBanner: (v: React.ReactNode | null) => void;
}

export const StickyHeaderContext =
  React.createContext<StickyHeaderContextValue>({
    hasStickyHeader: false,
    setHasStickyHeader: () => {},
    toggleSidebar: true,
    returnBanner: null,
    setReturnBanner: () => {}
  });
